import { jsx as _jsx } from "react/jsx-runtime";
import { DeviceConfigProvider } from './config';
import { DeviceStateProvider } from './state';
import { genericMemo } from '../../utils/memo';
export const displayDeviceName = (device) => {
    const { name, individual_device_name } = device;
    return individual_device_name?.trim() !== ''
        ? individual_device_name ?? name ?? ''
        : name ?? '';
};
/**
 * @function
 * Контекст устройства для всех вкладок
 * @param props - кусок устройства & другие контексты для вкладок
 */
export const DeviceContentProvider = genericMemo(function DeviceContentProvider(props) {
    const { device, children, tab_key } = props;
    const { id: device_id, ui_settings, online, hardware_type, capabilities, device_type, z3k_config, user_id, thermostat_enable_guard, tempstep = 0.5, access, timezone, iconState, } = device;
    return (_jsx(DeviceConfigProvider, { device_id: device_id, ui_settings: ui_settings, device_type: device_type, capabilities: capabilities, hardware_type: hardware_type, name: displayDeviceName(device), config: z3k_config, temp_step: tempstep, user_id: user_id, thermostat_enable_guard: thermostat_enable_guard, access: access, timezone: timezone, online: online, tab_key: tab_key, children: _jsx(DeviceStateProvider, { online: online, icon_state: iconState, children: children }) }));
});
